module.exports = __webpack_public_path__ + "static/media/NoteBlock_short_logo_tm.7aad43b2.png";